import { handleApiError } from 'BreetHelpers';
import {
	apiSlice,
	closeModals,
	logUserOut,
	openModal,
	selectFcmToken,
	setFcmToken,
	useAppDispatch,
	useAppSelector,
	useLogoutMutation,
	useRemoveFCMTokenMutation,
} from 'BreetRedux';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router';

export const useAuthApi = (lastVisited?: string) => {
	const dispatch = useAppDispatch();
	const fcmToken = useAppSelector(selectFcmToken) as unknown as string;

	const [loading, setLoading] = useState(false);

	const navigate = useNavigate();

	const [logout] = useLogoutMutation();
	const [removeFCMToken] = useRemoveFCMTokenMutation();

	const promptLogout = useCallback(() => {
		dispatch(openModal({ id: 'logout', hideCloseButton: true }));
	}, [dispatch]);

	const handleLogoutFinally = useCallback(() => {
		dispatch(logUserOut(lastVisited));
		dispatch(setFcmToken(''));
		navigate('/login', { replace: true })
			?.catch(console.error)
			.finally(() => {
				setTimeout(() => {
					dispatch(apiSlice.util.resetApiState());
					setLoading(false);
				}, 5000);
			});
	}, [dispatch, lastVisited, navigate]);

	const onLogout = useCallback(() => {
		setLoading(true);
		dispatch(closeModals());
		const removePromise = fcmToken ? removeFCMToken({ token: fcmToken }).unwrap().catch(handleApiError) : Promise.resolve();

		removePromise.catch(handleApiError).finally(() => {
			logout().unwrap().catch(handleApiError).finally(handleLogoutFinally);
		});
	}, [dispatch, logout, fcmToken, removeFCMToken, handleLogoutFinally]);

	return {
		onLogout,
		isLoading: loading,
		promptLogout,
	};
};
